import React from "react";
import Typography from "../../../../../Foundation/Typography/Typography";
import FlexBox from "../../../../FlexBox/FlexBox";
import PriceTag from "../../../../Tag/PriceTag";
import Divider from "../../../../Divider/Divider";
import clsx from "clsx";

export interface ILandingPriceListProps {
  price?: string;
  product_price_vae?: string;
  product_price_vad?: string;
  product_display_from_mention?: string;
  priceSubtitle?: string;
  vaeLabel?: string;
  vadLabel?: string;
  className?: string;
}

const LandingPriceList = (props: ILandingPriceListProps) => {
  const {
    price,
    product_price_vae,
    product_price_vad,
    product_display_from_mention,
    priceSubtitle,
    vaeLabel,
    vadLabel,
    className,
  } = props;
  const renderDisplayFromMention = () => {
    if (product_display_from_mention) {
      return (
        <Typography variant="ui4">{product_display_from_mention}</Typography>
      );
    }
    return null;
  };
  return (
    <div className={clsx("landing-price-list", className)}>
      {(price || product_price_vae || product_price_vad || priceSubtitle) && (
        <FlexBox direction="column" gap={10}>
          {/* Display prices based on VAE and VAD values */}
          {!product_price_vae ||
          !product_price_vad ||
          product_price_vae === product_price_vad ? (
            price && (
              // No VAE or VAD values, show normal price
              <FlexBox direction="column" gap={4}>
                {renderDisplayFromMention()}
                <Typography variant="h4">{price}</Typography>
              </FlexBox>
            )
          ) : (
            // Values are different, show both with tags
            <FlexBox direction="row" gap={24} align="center">
              <FlexBox gap={8} direction="column" align="flex-start">
                <PriceTag label={vaeLabel || "À EMPORTER"} />
                <Typography variant="h4">{product_price_vae}</Typography>
              </FlexBox>
              <Divider
                direction="vertical"
                size={30}
                weight={1}
                color="#6C6C6C"
              />
              <FlexBox gap={8} direction="column" align="flex-start">
                <PriceTag label={vadLabel || "EN LIVRAISON"} />
                <Typography variant="h4">{product_price_vad}</Typography>
              </FlexBox>
            </FlexBox>
          )}

          {/* subtitle */}
          {priceSubtitle && (
            <Typography variant="ui">{priceSubtitle}</Typography>
          )}
        </FlexBox>
      )}
    </div>
  );
};

export default LandingPriceList;
